export default "__VITE_ASSET__0QvWWCx1__"